import { Context, Dispatch, ReactNode, createContext, useReducer } from "react";
import {
  reducer,
  initialState,
  ClaimCheckState,
  ClaimCheckAction,
} from "./reducer";

export const ClaimCheckContext: Context<ClaimCheckState | null> =
  createContext<ClaimCheckState | null>(null);

export const ClaimCheckDispatchContext: Context<Dispatch<ClaimCheckAction> | null> =
  createContext<Dispatch<ClaimCheckAction> | null>(null);

export const ClaimCheckProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { currentStep, isLoading, error, visitedSteps } = state;

  return (
    <ClaimCheckContext.Provider
      value={{ currentStep, isLoading, error, visitedSteps }}
    >
      <ClaimCheckDispatchContext.Provider value={dispatch}>
        {children}
      </ClaimCheckDispatchContext.Provider>
    </ClaimCheckContext.Provider>
  );
};
